import apiClient from 'apiClient';
import debounce from 'helpers/async-debounce';
import errorLogger from 'helpers/error-logger';

const makeRequest = async (path, params = {}) => {
  try {
    return await apiClient.get(path, params);
  } catch (error) {
    errorLogger({
      error,
      consoleMessage: `Error fetching for path: "${path}", with params: ${JSON.stringify(
        params,
      )}, Error: ${JSON.stringify(error)}`,
    });
    return [];
  }
};

const fetchProjects = debounce(async (companyId, query) => {
  return makeRequest(`companies/${companyId}/search/projects`, { q: query });
}, 250);

const fetchUsers = debounce(async (companyId, query) => {
  return makeRequest(`companies/${companyId}/search/users`, { q: query });
}, 250);

const fetchGroups = debounce(async (companyId, query) => {
  return makeRequest(`companies/${companyId}/search/groups`, { q: query });
}, 250);

const fetchTags = async (companyId) => {
  return makeRequest(`/companies/${companyId}/tags`);
};

const fetchProjectTags = async (locationId) => {
  return makeRequest(`/locations/${locationId}/tags`);
};

const fetchProjectGroups = debounce(async (locationId, query) => {
  return makeRequest(`locations/${locationId}/groups/search`, { q: query });
}, 250);

const fetchProjectUsers = debounce(async (locationId, query) => {
  return makeRequest(`locations/${locationId}/users/search`, { q: query });
}, 250);

export {
  fetchGroups,
  fetchProjects,
  fetchProjectTags,
  fetchProjectUsers,
  fetchProjectGroups,
  fetchTags,
  fetchUsers,
};
